<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="userId" placeholder="请选择客户名称">
              {{ formData.userName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型" prop="headerType">
              {{ invoiceHeaderTypeMap.get(formData.headerType) || '企业' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="headerName">
              {{ formData.headerName }}
            </el-form-item>
          </el-col>
          <template v-if="formData.headerType === '2'">
            <el-col :span="12">
              <el-form-item label="税号" prop="taxNumber">
                {{ formData.taxNumber }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址" prop="headerAddress">
                {{ formData.headerAddress }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话" prop="headerPhone">
                {{ formData.headerPhone }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行" prop="bankName">
                {{ formData.bankName }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账号" prop="bankAccount">
                {{ formData.bankAccount }}
              </el-form-item>
            </el-col>
          </template>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { invoiceHeaderType } from '@/utils/dict'
export default {
  name: 'InvoiceTitleDetail',
  data() {
    return {
      invoiceHeaderTypeMap: invoiceHeaderType,
      formData: {
        headerId: '', // 抬头ID
        userId: '', // 关联客户id
        headerName: '', // 名称
        headerAddress: '', // 地址
        headerPhone: '', // 电话
        taxNumber: '', // 税号
        bankName: '', // 开户行
        bankAccount: '' // 开户行账号
      },
      loading: false
    }
  },
  created() {
    if (this.headerId) {
      this.loadData()
    }
  },
  computed: {
    headerId() {
      return this.$route.query.headerId
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceHeaderByHeaderId, {
        params: { headerId: this.headerId }
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.form {
  margin-top: 30px;
  width: 1000px;
}

.el-select {
  width: 100%;
}

.el-cascader {
  width: 100%;
}

.el-date-editor {
  width: 100%;
}
</style>
